import { Block } from "@block";
import { QueueSpacing, StackSpacing } from "@components/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { spacing } from "@styles/spacing";
import { fetchLoyaltyAccountRequest } from "app/modules/loyalty/reducer/actions";
import { getLoyaltyAccountSelector, getStatusLoyaltySelector } from "app/modules/loyalty/reducer/selectors";
import moment from "moment";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet, View } from "react-native";
import { Surface, Text, useTheme } from "react-native-paper";
import { useDispatch, useSelector } from "react-redux";
import { formatNumberThousand } from "../../../util/format-currency";
import IconsYellowBanking from "../../icons/icon-yellow-banking/IconsYellowBanking";

const BoxRedeem = () => {
  const { colors, fonts } = useTheme();
  const isDesktop = useDesktopMediaQuery();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();

  const [loyaltyPoint, setLoyaltyPoint] = React.useState("0");
  const [loyaltyExpireDate, setLoyaltyExpireDate] = React.useState(moment(moment.now()).format("DD/MM/YYYY"));

  const loyaltyAccount = useSelector(getLoyaltyAccountSelector);
  const statusLoyalty = useSelector(getStatusLoyaltySelector);

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        surface: { height: "100%", borderRadius: 20, display: loyaltyAccount || statusLoyalty === "ok" ? "flex" : "none" },
        viewContent: { paddingHorizontal: spacing.huge, flexDirection: isDesktop ? "row" : "column" },
        textLabel: { color: colors.text, ...fonts.medium, minWidth: "50%", fontSize: 13 },
        textValue: { color: colors.accent, ...fonts.semibold, minWidth: "50%", textAlign: isDesktop ? "right" : "left", fontSize: 13 },
      }),
    [colors.accent, colors.text, fonts.medium, fonts.semibold, isDesktop, statusLoyalty, loyaltyAccount],
  );

  React.useEffect(() => {
    if (loyaltyAccount) {
      if (loyaltyAccount?.CURRENT_POINT) {
        setLoyaltyPoint(loyaltyAccount?.CURRENT_POINT);
      }
      if (loyaltyAccount?.EXPIREDATE) {
        setLoyaltyExpireDate(loyaltyAccount?.EXPIREDATE);
      }
    }
  }, [loyaltyAccount]);

  React.useEffect(() => {
    dispatchStore(fetchLoyaltyAccountRequest());
  }, [dispatchStore]);

  return (
    <Surface style={styles.surface}>
      <Block ph={spacing.huge}>
        <IconsYellowBanking name="pvonelogo" size={56} />
      </Block>
      <View style={styles.viewContent}>
        <Text numberOfLines={1} style={styles.textLabel}>
          {t("LOYALTY_DIEM_HIEN_TAI")}
        </Text>
        <QueueSpacing size="small" />
        <Text style={styles.textValue}>
          {formatNumberThousand(loyaltyPoint)} {t("LOYALTY_DIEM")}
        </Text>
      </View>
      {/* <StackSpacing size="small" /> */}
      {/* <View style={styles.viewContent}>
        <Text numberOfLines={1} style={styles.textLabel}>
          {t("LOYALTY_DIEM_HET_HAN")}
        </Text>
        <QueueSpacing size="small" />
        <Text style={styles.textValue}>{moment(loyaltyExpireDate, "DD/MM/YYYY").format("DD/MM/YYYY")}</Text>
      </View> */}
      <StackSpacing size="large" />
    </Surface>
  );
};

export default BoxRedeem;
